import React, { Component } from 'react';
import CallAPI from '../commonComponents/AxiosHelper';
import { connect } from 'react-redux';
import { setToolId } from '../../action/index';
import { bindActionCreators } from 'redux';
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';
// import DatasetFilter from '../../react_components/DatasetFilter.jsx';

class DatasetFilter extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedData: null,
            datasets: null,
            test: null,
            toolId: props.toolId
        }

        this.handleChange = this.handleChange.bind(this)
    }

    componentWillMount() {
        let that = this;
        let params = { siteId: this.props.authData.siteId };
        let url = '/app/tools';
        let postData = { userId: this.props.authData.userId }
        CallAPI('post', url, postData, params, 0, function (response) {
            // response = decodeResponseBody(response)
            let toolId = that.props.toolId ? that.props.toolId : response.value[0].toolId
            that.setState({
                datasets: response,
                toolId: toolId
            })
            if (that.props.toolId === null) {
                that.props.setToolId(response.value[0]['toolId']);
            }
            // jQuery('.selectpicker').selectpicker('refresh');
        }, this.props.authData)
    }

    componentDidMount() { 
        // const dropdown = document.querySelectorAll('.js-choice');
        // dropdown.forEach((selectElement) => {
        //     new Choices(selectElement, {
        //         searchEnabled: true,
        //         shouldSort: false,
        //         classNames: {
        //             containerInner: 'custom-class-for-container',
        //             listDropdown: 'custom-class-for-dropdown'
        //         }
        //     }); 
        // });
     }

     componentDidUpdate(prevProps, prevState) {
        if (this.state.datasets !== prevState.datasets && this.state.datasets) {
            this.initializeChoices();
        }
    }
    handleChange(e){
        this.props.setToolId(e.target.value);
    }
    initializeChoices() {
        const dropdown = document.querySelectorAll('.js-choice');
        dropdown.forEach((selectElement) => {
            new Choices(selectElement, {
                searchEnabled: true,
                shouldSort: false,
                classNames: {
                    containerInner: 'custom-class-for-container',
                    listDropdown: 'custom-class-for-dropdown'
                }
            });
        });
    }
    render() {
        var optionContent = null;
        var selectDropdownComponent = null;
        if(this.state.datasets){
            try{
                let optionContentUserType = this.state.datasets.value.filter((element, i) => element.userType==1 || element.userType=="1").map((element,i)=>{
                    return (<option key={`${element['toolId']}_${i}`} value={element['toolId']}>{element['name']}</option>)
                });
                let optionContentVisiblity = this.state.datasets.value.filter((element, i) => element.visiblity==1 && element.userType!=1).map((element,i)=>{
                    return (<option key={`${element['toolId']}_${i}`} value={element['toolId']}>{element['name']}</option>)
                });
                optionContent = optionContentUserType.concat(optionContentVisiblity)
                selectDropdownComponent = (
                    <div className="">
                        <select
                            className="js-choice  form-control"
                            id={`dropdown-${Math.random().toString(36).substr(2, 5)}`}
                            onChange={this.handleChange}
                            value={this.props.toolId}
                        >
                            {optionContent}
                        </select>
                    </div>
                )

            }
            catch(e){
                selectDropdownComponent = null;
            }
        }



        return (
            <>
                {selectDropdownComponent}
            </>
        )
    }
}

function mapStateToProps(state) {

    return { toolId: state.admin.toolId, authData: state.dataSet.authData, toolsData: state.dataSet.dataResult };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
         setToolId
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DatasetFilter);

// export default DatasetFilter;